import React, { PureComponent } from 'react'
import { View } from 'react-native'
import styled from 'styled-components/native'

import { Text } from '../../Atoms/Typography'
import Icon from '../../Atoms/Icon'
import Logo from '../../Atoms/Logo'
import Touchable from '../../Atoms/Touchable'
import HeaderBar from '../../Molecules/HeaderBar'
import Clock from '../../Organisms/Header/Clock'

import theme from '../../../styles/theme'

const Container = styled(View)`
  flex: 1;
  background-color: ${theme.colours.white};
`

const Body = styled(View)`
  flex: 1;
  padding: ${3 * theme.gutterUnit}px;
  background-color: ${theme.colours.lightgrey};
  align-items: center;
  justify-content: center;
`

const BulletRow = styled(View)`
  flex-direction: row;
  align-items: center;
  margin-top: ${2 * theme.gutterUnit}px;
`

const ClockContainer = styled(View)`
  flex: 1;
  align-items: flex-end;
`

export default class NonMasterPage extends PureComponent {
  render () {
    const { lockScreen } = this.props
    return (
      <Container>
        <HeaderBar black>
          <Touchable onPress={lockScreen}>
            <Logo />
          </Touchable>
          <ClockContainer>
            <Clock black />
          </ClockContainer>
        </HeaderBar>
        <Body>
          <View>
            <Text size='l' bold>BANK DETAILS</Text>
            <Text overrides={{
              marginTop: 2 * theme.gutterUnit
            }}
            >As a team, please enter the following in your CEO tablet:
            </Text>
            <BulletRow>
              <Icon size='xxs' name='bullet' />
              <Text overrides={{
                marginLeft: theme.gutterUnit
              }}
              > Bank Name ( max 8 characters )
              </Text>
            </BulletRow>
            <BulletRow>
              <Icon size='xxs' name='bullet' />
              <Text overrides={{
                marginLeft: theme.gutterUnit
              }}
              >A guiding strategy built on company values
              </Text>
            </BulletRow>
            <Text
              italic size='s' overrides={{
                marginTop: 2 * theme.gutterUnit
              }}
            >This screen will disappear once these have been completed
            </Text>
          </View>
        </Body>
      </Container>
    )
  }
}
